<template>
  <aside class="menu">
    <ul class="menu-list">
      <li v-for="(warehouse, widx) in warehouses" :key="widx">
        <a
          :class="{ 'is-active': selected_warehouse == warehouse }"
          @click="set_warehouse(warehouse)"
        >
          <span class="icon mr-2">
            <i class="fa fa-home"></i>
          </span>
          <span>{{ warehouse.name }}</span></a
        >
      </li>
      <li>
        <div class="is-divider my-3"></div>
        <a
          :class="{ 'is-active': selected_warehouse == 'unorganized' }"
          @click="set_warehouse('unorganized')"
        >
          <span class="icon mr-2 has-text-warning">
            <i class="fa fa-cubes"></i>
          </span>
          <span>{{ $t("unorganized") }}</span></a
        >
      </li>
    </ul>
  </aside>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";

export default {
  name: "WarehouseList",
  components: { GenericTable },
  data() {
    return {
      warehouses: [],
      selected_warehouse: undefined,
    };
  },
  methods: {
    format_date_time,
    format_currency,
    refresh() {
      let v = this;
      get("/inventory/warehouse/list", {})
        .then((warehouses) => {
          v.warehouses = warehouses;
        })
        .catch((err) => {
          error_message(err);
        });
      // v.$refs.datatable.refresh();
    },
    set_warehouse(warehouse) {
      let v = this;
      v.selected_warehouse = warehouse;
      v.$emit("warehouse-selected", warehouse);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
